// ---------------------------------------------------------
// WARNING: THIS IS A GENERATED FILE, DO NOT EDIT DIRECTLY
// ---------------------------------------------------------

import { withNamespace } from '../util/withNamespace';
var theme = {
  accessibility: {
    targetSize: 44
  },
  animations: {
    defaultDuration: 0.2,
    defaultTimingFunction: 'ease-out'
  },
  borderWidths: {
    none: 0,
    xs: 1,
    sm: 2,
    md: 4,
    lg: 6,
    xl: 8
  },
  breakpoints: {
    xs: 0,
    sm: 321,
    md: 481,
    lg: 769,
    xl: 1024,
    xxl: 1281
  },
  colors: {
    white: '#FFF',
    gray100: '#F7F7F7',
    gray200: '#EEEEF0',
    gray300: '#CDCDD3',
    gray400: '#ADADB6',
    gray500: '#535364',
    gray600: '#2A2A33',
    black: '#111116',
    trueBlack: '#000',
    coolGray100: '#F7F7F7',
    coolGray200: '#EEEEF0',
    coolGray300: '#CDCDD3',
    coolGray400: '#ADADB6',
    coolGray500: '#535364',
    coolGray600: '#2A2A33',
    blue100: '#EEF6FF',
    blue200: '#DCEDFF',
    blue300: '#BFDFFF',
    blue375: '#65B4FF',
    blue400: '#0041D9',
    blue500: '#0033AB',
    blue600: '#001962',
    yellow100: '#FFEDC0',
    yellow200: '#FFE297',
    yellow300: '#FFD152',
    yellow400: '#F2B100',
    yellow500: '#BF8B00',
    yellow600: '#725200',
    orange100: '#FFE9E3',
    orange200: '#FFD7CA',
    orange300: '#FFC0AB',
    orange400: '#FFA385',
    orange500: '#FF4D29',
    orange600: '#D03C0B',
    green100: '#DAFACE',
    green200: '#C1F7AC',
    green300: '#9FF17B',
    green400: '#7DD157',
    green500: '#559E30',
    green600: '#2A6500',
    aqua100: '#D3F6FD',
    aqua200: '#73E4F9',
    aqua300: '#31CCE6',
    aqua400: '#006A79',
    aqua500: '#004550',
    aqua600: '#00343D',
    purple100: '#F7E3FF',
    purple200: '#F0CBFF',
    purple300: '#E6A8FF',
    purple400: '#C67EFF',
    purple500: '#891EFA',
    purple600: '#6000B6',
    red100: '#FFE4E1',
    red200: '#FFCDC8',
    red300: '#FFB4AF',
    red400: '#FF7E79',
    red500: '#EF002D',
    red600: '#AC001E',
    orangeRed100: '#FFC0AB',
    orangeRed200: '#FFA385',
    orangeRed300: '#FF4D29',
    orangeRed400: '#D03C0B',
    orangeRed500: '#7D2103',
    orangeRed600: '#561200',
    facebook: '#1877F2',
    twitter: '#55ACEE',
    linkedIn: '#0077B5',
    x: '#000000',
    none: 'none',
    transparent: 'transparent',
    brand: '#0041D9',
    brandSecondary: '#F2B100',
    backgroundBrand: '#0041D9',
    textWhite: '#FFF',
    textLight: '#ADADB6',
    textMedium: '#535364',
    textDark: '#111116',
    link: '#0041D9',
    linkFocus: '#0033AB',
    linkInverse: '#FFF',
    linkVisited: '#6000B6',
    linkHover: '#001962',
    linkActive: '#001962',
    backgroundAqua: '#D3F6FD',
    backgroundBlue: '#EEF6FF',
    backgroundGreen: '#DAFACE',
    backgroundOrange: '#FFE9E3',
    backgroundOrangeRed: '#FFC0AB',
    backgroundPurple: '#F7E3FF',
    backgroundRed: '#FFE4E1',
    backgroundYellow: '#FFEDC0',
    backgroundDarkAqua: '#00343D',
    backgroundDarkBlue: '#001962',
    backgroundDarkGreen: '#2A6500',
    backgroundDarkOrange: '#D03C0B',
    backgroundDarkOrangeRed: '#561200',
    backgroundDarkPurple: '#6000B6',
    backgroundDarkRed: '#AC001E',
    backgroundDarkYellow: '#725200',
    backgroundWhite: '#FFF',
    backgroundLight: '#F7F7F7',
    backgroundDark: '#2A2A33',
    borderAqua: '#004550',
    borderBlue: '#0033AB',
    borderGreen: '#559E30',
    borderOrange: '#FF4D29',
    borderOrangeRed: '#EF002D',
    borderPurple: '#891EFA',
    borderRed: '#EF002D',
    borderYellow: '#BF8B00',
    borderLight: '#CDCDD3',
    borderDark: '#ADADB6',
    offMarket: '#ADADB6',
    comingSoon: '#0041D9',
    recentlySold: '#FFD152',
    forRent: '#C67EFF',
    forSale: '#FF7E79',
    primary100: '#EEF6FF',
    primary200: '#DCEDFF',
    primary300: '#BFDFFF',
    primary400: '#0041D9',
    primary500: '#0033AB',
    primary600: '#001962',
    secondary100: '#FFEDC0',
    secondary200: '#FFE297',
    secondary300: '#FFD152',
    secondary400: '#F2B100',
    secondary500: '#BF8B00',
    secondary600: '#725200'
  },
  defaultUnit: 'px',
  fonts: {
    sansSerif: '"Inter", "Adjusted Arial", Tahoma, Geneva, sans-serif',
    serif: '"Object Sans", "Adjusted Arial", Tahoma, Geneva, sans-serif'
  },
  fontSizes: {
    h0: 96,
    h1: 60,
    h2: 44,
    h3: 36,
    h4: 24,
    h5: 20,
    h6: 16,
    bodyHeading: 16,
    body: 16,
    bodySmallHeading: 14,
    bodySmall: 14,
    finePrintHeading: 12,
    finePrint: 12,
    legal: 10
  },
  fontWeights: {
    bold: 700,
    normal: 400,
    h0: 900,
    h1: 900,
    h2: 900,
    h3: 900,
    h4: 900,
    h5: 900,
    h6: 700,
    bodyHeading: 700,
    body: 400,
    bodySmallHeading: 700,
    bodySmall: 400,
    finePrintHeading: 700,
    finePrint: 400,
    legal: 400
  },
  gridBase: 8,
  icons: {
    sizes: {
      xs: 16,
      sm: 24,
      md: 32,
      lg: 44
    }
  },
  detailedIcons: {
    sizes: {
      sm: 44
    }
  },
  lineHeights: {
    h0: 112,
    h1: 72,
    h2: 56,
    h3: 40,
    h4: 32,
    h5: 24,
    h6: 24,
    bodyHeading: 24,
    body: 24,
    bodySmallHeading: 24,
    bodySmall: 24,
    finePrintHeading: 16,
    finePrint: 16,
    legal: 16
  },
  opacities: {
    opacity100: 0.2,
    opacity200: 0.4,
    opacity300: 0.6,
    opacity400: 0.8,
    opacity500: 1,
    disabled: 0.4,
    mask: 0.2
  },
  radii: {
    none: 0,
    sm: 12,
    md: 12,
    lg: 20,
    ellipse: '50%',
    pill: '999px'
  },
  shadows: {
    none: 'none',
    shadow100: '0 4px 15px rgba(0, 0, 0, 0.15)',
    shadow200: '0 7px 20px rgba(0, 0, 0, 0.15)',
    shadow300: '0 15px 30px rgba(0, 0, 0, 0.15)',
    shadow400: '0 15px 30px rgba(0, 0, 0, 0.15)',
    focus: '0 0 2px 3px #BFDFFF,0 0 2px 4px #0041D9'
  },
  spacing: {
    none: 0,
    xxs: 4,
    xs: 8,
    sm: 16,
    md: 24,
    lg: 32,
    xl: 48
  },
  sizes: {
    heights: {
      xs: 28,
      sm: 36,
      md: 44,
      lg: 56
    }
  },
  zIndices: {
    modal: 100002,
    popover: 100011,
    dialog: 100013,
    toast: 200000
  },
  grid: {
    columns: 12,
    columnWidth: 88,
    gap: 16
  },
  status: {
    fontType: 'body',
    iconSize: 24,
    error: {
      background: '#FFE4E1',
      border: '#EF002D',
      foreground: '#EF002D',
      fontColor: '#AC001E',
      darkBackground: '#AC001E'
    },
    info: {
      background: '#EEF6FF',
      border: '#0033AB',
      foreground: '#001962',
      fontColor: '#001962',
      darkBackground: '#001962'
    },
    success: {
      background: '#DAFACE',
      border: '#559E30',
      foreground: '#559E30',
      fontColor: '#2A6500',
      darkBackground: '#2A6500'
    },
    warning: {
      background: '#FFEDC0',
      border: '#BF8B00',
      foreground: '#FFA385',
      fontColor: '#725200',
      darkBackground: '#FF4D29'
    },
    transient: {
      foreground: '#0041D9'
    }
  },
  AccordionHeader: {
    backgroundColor: '#FFF',
    backgroundColorHover: '#F7F7F7',
    borderRadius: 12,
    padding: 16,
    textDecorationHover: 'underline'
  },
  AccordionItem: {
    borderColor: '#CDCDD3',
    borderRadius: 12,
    borderWidth: 1,
    spacing: 8
  },
  AccordionPanel: {
    backgroundColor: '#FFF',
    borderColor: '#CDCDD3',
    borderRadius: 12,
    borderWidth: 1,
    padding: 16,
    margin: 0
  },
  Adornment: {
    borderRadius: 12,
    boxShadow: {
      focus: '0 0 2px 3px #BFDFFF,0 0 2px 4px #0041D9'
    },
    Left: {
      paddingLeft: 0,
      borderLeft: 0,
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0
    },
    Right: {
      paddingRight: 0,
      borderRight: 0,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0
    },
    ReadOnly: {
      backgroundColor: 'transparent',
      borderColor: 'transparent'
    }
  },
  Alert: {
    borderRadius: 12,
    Toast: {
      Body: {
        flex: '1 1 0'
      },
      Action: {
        flex: '1 1 100%',
        iconSize: 24,
        marginLeft: 'sm',
        marginTop: 8,
        order: 2
      }
    }
  },
  Anchor: {
    textDecoration: 'underline',
    defaultColor: '#0041D9',
    focusColor: '#0033AB',
    visitedColor: '#6000B6',
    hoverColor: '#001962',
    activeColor: '#001962',
    inverseColor: '#FFF'
  },
  Avatar: {
    sizes: {
      xs: 24,
      sm: 32,
      md: 48,
      lg: 64,
      xl: 96,
      xxl: 160
    },
    fontTypes: {
      xs: 'bodySmallHeading',
      sm: 'h6',
      md: 'h5',
      lg: 'h4',
      xl: 'h3',
      xxl: 'h1'
    },
    iconColorOnLight: '#ADADB6',
    iconColorOnDark: '#FFF',
    defaultBackgroundColor: '#EEEEF0',
    colorOnLight: '#111116',
    colorOnDark: '#FFF',
    borderRadius: '50%'
  },
  AvatarBadge: {
    badgeSizes: {
      xxl: 48,
      xl: 36,
      lg: 28
    },
    iconSizes: {
      xxl: 32,
      xl: 24,
      lg: 16
    },
    foregroundColor: '#FFF',
    backgroundColor: '#0041D9',
    borderColor: '#FFF',
    borderRadius: '50%',
    borderWidth: 2
  },
  Banner: {
    borderRadius: 0,
    boxShadow: 'none',
    withCloseButton: {
      actionBodyMarginRight: 16,
      actionBodyMarginLeft: 0
    }
  },
  Button: {
    fontType: 'bodyHeading',
    fontTypeSmall: 'bodySmallHeading',
    borderRadius: 12,
    borderWidth: 1,
    horizontalPadding: 16,
    targetSize: 44,
    margin: 0,
    transitionDuration: 0.2,
    transitionProperty: 'background-color, border-color, color',
    transitionTimingFunction: 'ease',
    pressed: {
      borderWidth: 2,
      horizontalPadding: 15
    },
    primary: {
      fontColor: '#FFF',
      fontColorHover: '#FFF',
      fontColorActive: '#FFF',
      fontColorPressed: '#FFF',
      borderColor: '#0041D9',
      borderColorHover: '#0033AB',
      borderColorActive: '#001962',
      borderColorPressed: '#001962',
      backgroundColor: '#0041D9',
      backgroundColorHover: '#0033AB',
      backgroundColorActive: '#001962',
      backgroundColorPressed: '#001962'
    },
    secondary: {
      fontColor: '#0041D9',
      fontColorHover: '#0033AB',
      fontColorActive: '#001962',
      fontColorPressed: '#FFF',
      borderColor: '#0041D9',
      borderColorHover: '#0033AB',
      borderColorActive: '#001962',
      borderColorPressed: '#001962',
      backgroundColor: '#FFF',
      backgroundColorHover: '#EEF6FF',
      backgroundColorActive: '#DCEDFF',
      backgroundColorPressed: '#001962'
    },
    tertiary: {
      fontColor: '#2A2A33',
      fontColorHover: '#2A2A33',
      fontColorActive: '#2A2A33',
      fontColorPressed: '#2A2A33',
      borderColor: '#ADADB6',
      borderColorHover: '#ADADB6',
      borderColorActive: '#535364',
      borderColorPressed: '#0041D9',
      backgroundColor: '#FFF',
      backgroundColorHover: '#EEEEF0',
      backgroundColorActive: '#CDCDD3',
      backgroundColorPressed: '#EEF6FF'
    },
    caution: {
      fontColor: '#FFF',
      fontColorHover: '#AC001E',
      fontColorActive: '#FFF',
      fontColorPressed: '#FFF',
      borderColor: '#EF002D',
      borderColorHover: '#AC001E',
      borderColorActive: '#AC001E',
      borderColorPressed: '#AC001E',
      backgroundColor: '#EF002D',
      backgroundColorHover: '#FFF',
      backgroundColorActive: '#AC001E',
      backgroundColorPressed: '#AC001E'
    },
    primaryInverse: {
      fontColor: '#0041D9',
      fontColorHover: '#0033AB',
      fontColorActive: '#001962',
      borderColor: '#FFF',
      borderColorHover: '#FFF',
      borderColorActive: '#FFF',
      backgroundColor: '#FFF',
      backgroundColorHover: '#EEF6FF',
      backgroundColorActive: '#DCEDFF'
    },
    secondaryInverse: {
      fontColor: '#FFF',
      fontColorHover: '#2A2A33',
      fontColorActive: '#2A2A33',
      borderColor: '#FFF',
      borderColorHover: '#FFF',
      borderColorActive: '#FFF',
      backgroundColor: 'transparent',
      backgroundColorHover: '#EEEEF0',
      backgroundColorActive: '#CDCDD3'
    },
    icon: {
      marginX: 8
    }
  },
  Card: {
    backgroundColor: '#FFF',
    borderWidth: 1,
    borderColor: '#CDCDD3',
    borderColorPrimary: '#0041D9',
    borderRadius: 12,
    separatorColor: '#CDCDD3',
    padding: 'sm',
    borderWidthPrimary: 3,
    section: {
      paddingBottom: 24,
      marginBottom: 24,
      borderBottomWidth: 1
    },
    interactive: {
      backgroundColor: {
        hover: '#EEF6FF'
      },
      transitionProperty: 'background-color, box-shadow',
      transitionDuration: 0.2,
      transitionTimingFunction: 'ease',
      borderColor: {
        pressed: '#0041D9'
      },
      borderWidth: {
        pressed: 2
      }
    }
  },
  CardButton: {
    fontType: 'h6',
    fontColor: '#0041D9',
    padding: 0,
    borderWidthTop: 1,
    paddingTop: 16,
    marginTop: 24,
    textAlign: 'center',
    width: '100%',
    textDecoration: {
      hover: 'underline'
    }
  },
  CardHeader: {
    fontType: 'h5',
    marginTop: 0,
    marginBottom: 24,
    borderBottomWidth: 1,
    paddingBottom: 16
  },
  CarouselHeader: {
    gridGap: 32,
    paddingBottom: 8
  },
  CarouselScrollContainer: {
    margin: 0,
    scrollOffset: {
      paddingTop: 8,
      paddingBottom: 18,
      scrollPaddingY: 0
    }
  },
  CarouselSkipLink: {
    height: 44,
    background: '#FFF',
    margin: 0,
    width: '100%'
  },
  CarouselNavControls: {
    gridColumnGap: 16
  },
  Chip: {
    avatarSize: 24,
    borderRadius: '999px',
    borderWidth: 1,
    boxShadow: {
      default: '0 4px 15px rgba(0, 0, 0, 0.15)',
      focus: '0 0 2px 3px #BFDFFF,0 0 2px 4px #0041D9'
    },
    chevronPadding: 32,
    chevronPosX: 9,
    fontColor: '#111116',
    fontType: 'bodySmallHeading',
    height: 28,
    horizontalSpacing: 8,
    iconPosX: 10,
    opacity: {
      disabled: 0.4
    },
    spinnerSize: 16,
    targetSize: 36,
    closeButton: {
      opacityActive: 0.4,
      colorActive: '#ADADB6'
    },
    pressed: {
      backgroundColorHover: '#DCEDFF',
      borderWidth: 2,
      chevronPadding: 31,
      chevronPosX: 10,
      horizontalSpacing: 7,
      iconPosX: 9
    }
  },
  CloseButton: {
    buttonSize: 24,
    iconColor: '#111116',
    border: 0,
    backgroundColor: '#EEEEF0',
    backgroundColorInverse: 'rgba(255, 255, 255, 0.3)',
    padding: 8,
    margin: -8,
    boxShadowFocus: '0 0 2px 3px #BFDFFF,0 0 2px 4px #0041D9',
    borderRadius: '50%'
  },
  ComboboxInput: {
    tagMargin: 4,
    minInputWidth: '25%',
    boxShadow: {
      focus: '0 0 2px 3px #BFDFFF,0 0 2px 4px #0041D9'
    },
    TagCloseButton: {
      opacity: {
        disabled: 1
      },
      cursor: {
        disabled: 'default'
      }
    },
    select: {
      basePaddingSize: 'xs'
    },
    Listbox: {
      border: 0
    },
    Input: {
      border: 0,
      padding: 0,
      boxShadow: 'none'
    }
  },
  ComboboxLoadingState: {
    verticalSpacing: 12
  },
  Combobox: {
    Dropdown: {
      width: '100%'
    },
    Listbox: {
      border: 0
    }
  },
  ComboboxOption: {
    Highlight: {
      fontWeight: 700,
      backgroundColor: 'transparent'
    }
  },
  Datepicker: {
    backgroundColor: '#FFF',
    Week: {
      paddingTop: 8
    },
    DayHeader: {
      height: 'xs',
      lineHeight: 36,
      borderBottomWidth: 1,
      borderColor: '#CDCDD3',
      paddingTop: 0,
      textAlign: 'center'
    },
    Date: {
      height: 40,
      padding: 4
    }
  },
  DatePickerButton: {
    borderRadius: '50%',
    size: 36,
    padding: 0,
    Icon: {
      margin: 0
    }
  },
  DatePickerSelect: {
    caretSize: 28,
    paddingLeft: 4,
    boxShadow: {
      focus: '0 0 2px 3px #BFDFFF,0 0 2px 4px #0041D9'
    },
    Select: {
      fontType: 'bodyHeading',
      padding: 0,
      paddingRight: 32,
      backgroundColor: {
        hover: '#EEEEF0'
      }
    },
    Button: {
      top: 0,
      right: 0,
      icon: {
        size: 10,
        rotate: '90deg'
      }
    }
  },
  DetailedIcon: {
    noFill: 'none',
    white: '#FFF',
    defaultSize: 44,
    info: {
      foregroundColor: '#0033AB',
      secondaryColor: '#BFDFFF',
      accentColor: '#F2B100'
    },
    success: {
      foregroundColor: '#2A6500',
      secondaryColor: '#C1F7AC',
      accentColor: '#F2B100'
    }
  },
  Dialog: {
    minWidth: 200,
    maxWidth: 360,
    headingFontType: 'h5',
    borderRadius: 12,
    backgroundColor: '#FFF',
    boxShadow: '0 15px 30px rgba(0, 0, 0, 0.15)'
  },
  Divider: {
    lengths: {
      auto: 'auto',
      fixed: 144,
      fluid: '100%'
    },
    regular: {
      backgroundColor: '#CDCDD3',
      thickness: 1
    },
    emphasized: {
      backgroundColor: '#FFD152',
      thickness: 2
    }
  },
  Dropdown: {
    borderRadius: 12,
    horizontalSpacing: 16,
    verticalSpacing: 12,
    zIndex: 100011,
    Footer: {
      margin: 0
    }
  },
  DropdownHeading: {
    fontType: 'bodySmallHeading',
    fontColor: '#535364',
    iconSize: 'sm',
    backgroundColor: '#F7F7F7',
    horizontalSpacing: 16,
    verticalSpacing: 12,
    Icon: {
      marginRight: 8
    }
  },
  DropdownIcon: {
    iconColor: '#0041D9',
    size: 'md'
  },
  Form: {
    FormField: {
      marginBottom: 16
    },
    FormActions: {
      marginTop: 32
    }
  },
  FormField: {
    Label: {
      paddingBottom: 4
    },
    Help: {
      marginTop: 4
    },
    LabeledControl: {
      marginLeft: 8
    },
    ButtonGroup: {
      marginTop: 8
    }
  },
  FormHelp: {
    fontType: 'finePrint',
    fontColor: '#535364',
    error: {
      fontColor: '#AC001E'
    }
  },
  Gleam: {
    height: 20,
    padding: 6,
    fontType: 'bodySmallHeading',
    borderRadius: '999px',
    default: {
      fontColor: '#FFF',
      backgroundColor: '#D03C0B',
      inverse: {
        fontColor: '#FFF',
        backgroundColor: '#D03C0B'
      }
    },
    info: {
      fontColor: '#FFF',
      backgroundColor: '#0033AB',
      inverse: {
        fontColor: '#001962',
        backgroundColor: '#DCEDFF'
      }
    },
    new: {
      fontColor: '#FFF',
      backgroundColor: '#559E30',
      inverse: {
        fontColor: '#2A6500',
        backgroundColor: '#DAFACE'
      }
    }
  },
  GleamWrapper: {
    position: {
      top: 8,
      right: 8
    }
  },
  GridContent: {
    backgroundColor: '#FFF',
    borderRadius: 12
  },
  Heading: {
    defaultFontFamily: {
      h0: 'serif',
      h1: 'serif',
      h2: 'serif',
      h3: 'serif',
      h4: 'serif',
      h5: 'serif',
      h6: 'sansSerif'
    }
  },
  IconButton: {
    size: {
      xs: 28,
      sm: 36,
      md: 44,
      lg: 56
    },
    circle: {
      borderRadius: '50%'
    }
  },
  InlineFeedback: {
    fontType: 'body',
    iconSize: 24,
    paddingLeft: 'sm'
  },
  Input: {
    fontType: 'body',
    borderWidth: 1,
    horizontalSpacing: 16,
    fontColor: '#111116',
    fontColorPlaceholder: '#535364',
    backgroundColor: '#F7F7F7',
    backgroundColorAutofill: '#DCEDFF',
    backgroundColorInteractive: '#FFF',
    borderRadius: 12,
    borderColor: '#CDCDD3',
    borderColorError: '#AC001E',
    borderColorInteractive: '#0041D9',
    adornmentColor: '#535364',
    focus: {
      boxShadow: '0 0 2px 3px #BFDFFF,0 0 2px 4px #0041D9'
    },
    readonly: {
      paddingLeft: 0,
      paddingRight: 0,
      backgroundColor: 'transparent'
    }
  },
  Label: {
    fontTypes: {
      md: 'bodySmallHeading',
      lg: 'bodyHeading'
    },
    asteriskColor: '#AC001E',
    optionalColor: '#535364'
  },
  LabeledControl: {
    fontType: 'body',
    desiredHeight: 44,
    Label: {
      paddingLeft: 8,
      paddingRight: 8
    }
  },
  LabeledInput: {
    fontTypeInput: 'body',
    fontTypeLabel: 'finePrintHeading',
    scale: 0.75,
    transition: '0.15s all',
    verticalSpacing: 8,
    horizontalSpacing: 16,
    paddingBase: 15
  },
  LabeledRatingStars: {
    marginRight: 8,
    buttonType: 'secondary',
    fontType: 'bodySmall'
  },
  List: {
    fontType: 'body',
    borderColor: '#CDCDD3',
    borderWidth: 1,
    paddingLeft: 32,
    Item: {
      paddingTop: 'xs',
      paddingBottom: 0,
      horizontalTable: {
        paddingLeft: 16,
        paddingRight: 16
      }
    }
  },
  Listbox: {
    borderRadius: 12,
    sizes: {
      md: 220
    }
  },
  ListboxGroupLabel: {
    fontType: 'bodySmallHeading',
    fontColor: '#535364',
    backgroundColor: '#F7F7F7',
    textTransform: 'uppercase'
  },
  ListboxOption: {
    backgroundColorActive: '#EEF6FF',
    fontType: 'body',
    iconSize: 'sm',
    iconColor: '#535364',
    mediaSize: 24,
    metaColor: '#535364',
    horizontalSpacing: 16,
    verticalSpacing: 12,
    Label: {
      fontWeight: 700
    }
  },
  LoadingMask: {
    opacity: 0.2
  },
  Mask: {
    backgroundColor: '#000'
  },
  MenuContent: {
    fontType: 'finePrint',
    horizontalSpacing: 16,
    verticalSpacing: 12,
    margin: 0
  },
  MenuItem: {
    backgroundColor: '#FFF',
    backgroundColorHover: '#EEF6FF',
    border: 0,
    fontColor: '#111116',
    fontType: 'body',
    horizontalSpacing: 16,
    verticalSpacing: 12,
    textAlign: 'left',
    textDecoration: {
      hover: 'none'
    },
    anchor: {
      textDecoration: {
        hover: 'underline'
      },
      color: {
        hover: '#001962'
      }
    },
    Icon: {
      size: 'sm',
      color: '#535364',
      marginRight: 8
    }
  },
  Modal: {
    viewportPaddingVertical: 48,
    viewportPaddingHorizontal: 16,
    zIndex: 100002,
    boxShadow: '0 15px 30px rgba(0, 0, 0, 0.15)'
  },
  ModalDialog: {
    padding: 16,
    separatorColor: '#CDCDD3',
    separatorWidth: 1,
    borderRadius: 20,
    sizes: {
      xs: 360,
      sm: 540,
      md: 720,
      lg: 900,
      xl: 1080,
      fullScreen: 100
    },
    fullscreen: {
      borderRadius: 0,
      padding: 0
    }
  },
  NumberRating: {
    iconFontSize: 14,
    color: '#0041D9',
    Text: {
      marginRight: 4
    }
  },
  Page: {
    backgroundColor: '#F7F7F7',
    maxWidth: 1232,
    horizontalPadding: 24,
    horizontalPaddingMobile: 16,
    verticalMargin: 32
  },
  PaginationButton: {
    radius: '50%',
    size: 44,
    padding: 0
  },
  PaginationItem: {
    marginY: 0,
    marginX: 2,
    textAlign: 'center'
  },
  PaginationJumpItem: {
    marginY: 0,
    marginX: 8
  },
  PaginationList: {
    margin: 0,
    padding: 0,
    alignItems: 'center'
  },
  PhotoCarousel: {
    focusBoxShadow: '0 0 2px 3px #BFDFFF,0 0 2px 4px #0041D9',
    animations: {
      defaultDuration: 0.2,
      defaultTimingFunction: 'cubic-bezier(.58, .92, .57, .92)'
    },
    controlIcon: {
      color: '#FFF',
      transition: {
        easing: 'ease',
        duration: 0.2,
        property: 'opacity'
      },
      opacity: {
        active: 1,
        inactive: 0
      },
      zIndex: {
        active: 1,
        inactive: -1
      },
      previous: {
        filter: 'drop-shadow(2px 0 2px rgba(0, 0, 0, 0.3))'
      },
      next: {
        filter: 'drop-shadow(-2px 0 2px rgba(0, 0, 0, 0.3))'
      }
    },
    keyboardInstructions: {
      bottom: 30,
      transition: {
        duration: 0.4,
        property: 'all'
      }
    },
    dot: {
      backgroundColor: '#FFF',
      borderRadius: '50%',
      opacity: 0.6,
      boxShadow: '0 4px 15px rgba(0, 0, 0, 0.15)',
      marginY: 0,
      marginX: 4,
      position: {
        bottom: 6
      },
      size: {
        sm: 4,
        md: 6,
        lg: 8
      },
      active: {
        opacity: 1
      },
      transition: {
        easing: 'linear',
        duration: 0.15,
        property: 'all',
        delay: 0
      }
    },
    slide: {
      horizontalTranslations: {
        left: -100,
        center: 0,
        right: 100
      },
      zIndices: {
        left: 1,
        center: 2,
        right: 1
      }
    }
  },
  Popover: {
    maxHeight: 320,
    headingFontType: 'h6',
    padding: 16,
    arrowOuterSize: 40,
    arrowInnerSize: 17,
    arrowAlignStart: -9,
    arrowAlignCenter: 12,
    arrowAlignEnd: 31,
    arrowZIndex: 100011,
    separatorColor: '#CDCDD3',
    separatorWidth: 1,
    icon: {
      size: 24
    },
    Dialog: {
      zIndex: 100011,
      borderRadius: 12,
      gradientDirection: '180deg',
      startingColor: 'rgba(255, 255, 255, 0)',
      startingColorPosition: '0%',
      endingColorPosition: '100%'
    }
  },
  ProgressMeter: {
    sizes: {
      sm: 8,
      md: 16
    },
    backgroundColor: '#ADADB6',
    borderRadius: 12,
    indicatorColorInProgress: '#0033AB',
    indicatorColorCompleted: '#9FF17B',
    transition: '0.2s ease-in-out'
  },
  ProgressStepper: {
    currentStepSize: 36,
    nonInteractiveStepSize: 4,
    interactiveStepSize: 20,
    nonInteractiveLabelColor: '#535364',
    interactiveLabelColor: '#0033AB',
    stepBorderWidth: 6,
    stepPaddingX: 2,
    tagMarginTop: 4,
    labelFontType: 'bodySmall',
    labelOffset: 12,
    labelLineHeight: 24,
    backgroundColor: '#ADADB6',
    indicatorColor: '#0033AB',
    stepBackgroundColor: '#FFF',
    activeStepBackgroundColor: '#0041D9',
    activeStepBorderColor: '#FFF',
    activeStepLabelColor: '#111116',
    activeStepBoxShadow: 'inset 0 0 0 2px #0041D9',
    boxShadowRing: '0 0 0 8px rgba(0,51,171,0.2)',
    ringColor: 'rgba(0,51,171,0.2)',
    ringSize: 16,
    status: {
      complete: {
        foreground: '#0033AB',
        boxShadow: 'inset 0 0 0 2px #0033AB'
      },
      incomplete: {
        foreground: '#0033AB',
        boxShadow: 'inset 0 0 0 2px #0033AB'
      },
      warning: {
        foreground: '#FFA385',
        boxShadow: 'inset 0 0 0 2px #0033AB',
        iconSize: 24,
        filler: {
          width: 4,
          height: 12
        }
      },
      error: {
        foreground: '#EF002D',
        boxShadow: 'inset 0 0 0 2px #EF002D'
      },
      none: {
        foreground: 'inherit',
        boxShadow: ''
      }
    },
    label: {
      lineHeight: 24,
      marginTop: {
        current: 0
      },
      fontWeight: {
        current: 700,
        interactive: 700
      }
    },
    dot: {
      borderRadius: '50%',
      transition: {
        property: {
          interactive: 'transform'
        },
        duration: {
          interactive: 0.2
        },
        easing: {
          interactive: 'ease'
        }
      }
    }
  },
  PropertyCard: {
    action: {
      columnGap: 16,
      icon: {
        size: 24
      }
    },
    badge: {
      backgroundColor: {
        default: 'orange600',
        notification: 'white',
        zillow: 'blue400'
      },
      borderRadius: '999px',
      fontColor: {
        default: '#FFF',
        notification: '#111116',
        zillow: '#FFF'
      },
      fontType: 'finePrintHeading',
      horizontalPadding: 8,
      opacity: {
        default: 1,
        notification: 1,
        zillow: 1
      },
      verticalPadding: 2
    },
    cardBody: {
      borderRadius: 12,
      boxShadow: {
        flag: '0 7px 20px rgba(0, 0, 0, 0.15)',
        hover: {
          flag: '0 15px 30px rgba(0, 0, 0, 0.15)'
        },
        focus: '0 0 2px 3px #BFDFFF,0 0 2px 4px #0041D9'
      },
      gridTemplate: {
        large: '177px 1fr auto',
        small: '123px minmax(112px, 1fr)',
        horizontal: '116px 1fr',
        flag: '120px 1fr'
      },
      padding: 0,
      color: {
        hover: '#FFF'
      }
    },
    data: {
      gap: 8,
      pipeColor: '#ADADB6',
      lineHeight: 1,
      marginBottom: 8,
      marginTop: 8,
      childrenWidth: {
        one: '6em',
        two: '95%',
        three: '85%'
      },
      title: {
        fontColor: '#111116',
        fontType: {
          large: 'h5',
          small: 'h6',
          horizontal: 'h5',
          flag: 'h6'
        },
        fontFamily: 'serif'
      },
      body1: {
        fontColor: '#111116',
        fontType: 'bodySmall',
        fontFamily: 'sansSerif'
      },
      body2: {
        fontColor: '#111116',
        fontType: 'bodySmall',
        fontFamily: 'sansSerif'
      },
      body3: {
        fontColor: '#111116',
        fontType: 'bodySmall',
        fontFamily: 'sansSerif'
      },
      additionalInfo: {
        fontColor: '#535364',
        fontType: 'legal',
        fontFamily: 'sansSerif'
      },
      wrapper: {
        padding: {
          flag: {
            Y: 4,
            X: 8
          },
          default: 8
        }
      }
    },
    fallbackImage: {
      fill: '#CDCDD3',
      size: {
        large: 70,
        small: 42,
        horizontal: 42,
        flag: 32
      }
    },
    flexArea: {
      padding: 8
    },
    gridTemplateAreas: {
      large: '"photo" "data" "flex"',
      small: '"photo" "data"',
      horizontal: '"photo data"',
      flag: '"photo data"'
    },
    loading: {
      backgroundColor: '#EEEEF0',
      backgroundImage: 'linear-gradient(to right, #EEEEF0, #F7F7F7, #EEEEF0)'
    },
    maxWidth: {
      large: 386,
      small: 244,
      horizontal: 393,
      flag: 332
    },
    minWidth: {
      large: 286,
      small: 144,
      horizontal: 293,
      flag: 232
    },
    mls: {
      background: 'linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 50%, rgba(0, 0, 0, 0.5) 100%)',
      fontColor: '#FFF',
      fontWeight: 700,
      fontType: {
        large: 'finePrintHeading',
        small: 'legal',
        horizontal: 'legal',
        flag: 'legal'
      },
      textShadow: '0 1px 1px rgba(0, 0, 0, 0.2)',
      logo: {
        maxHeight: 23,
        maxWidth: 100
      },
      text: {
        align: {
          large: 'right',
          default: 'left'
        }
      },
      footer: {
        gap: 8,
        templateColumns: '1fr min-content',
        text: {
          paddingBottom: 2,
          fontWeight: 700
        },
        padding: {
          top: 8,
          right: 4,
          bottom: 4,
          left: 8
        }
      }
    },
    photo: {
      backgroundBlur: 8,
      backgroundColor: '#F7F7F7',
      borderRadius: 12,
      gridRows: 'auto 1fr auto',
      animation: {
        duration: 1.5,
        iterations: 'infinite'
      },
      header: {
        gap: 16,
        marginTop: 8,
        padding: {
          X: 8,
          Y: 0
        }
      }
    },
    popperMenu: {
      iconSize: 24,
      default: {
        fill: 'transparent',
        backgroundColor: {
          hover: 'transparent'
        }
      },
      boxShadow: {
        focus: '0 0 2px 3px #BFDFFF,0 0 2px 4px #0041D9'
      }
    },
    saveArea: {
      gap: 16,
      marginTop: 8,
      marginRight: 8
    },
    saveButton: {
      padding: {
        top: 8,
        right: 8,
        bottom: 16,
        left: 16
      },
      border: 0,
      icon: {
        size: 32,
        shadow: '0 2px 4px rgba(0,0,0,0.3)',
        fill: {
          default: 'rgba(0, 0, 0, 0.5)',
          hover: 'rgba(0, 0, 0, 0.75)'
        }
      }
    },
    width: {
      flag: 282
    }
  },
  Range: {
    width: '100%',
    margin: {
      X: 0,
      Y: 11
    },
    boxShadow: {
      default: 'none',
      focus: 'none'
    },
    outline: {
      focus: 'none'
    },
    Thumb: {
      boxShadow: {
        focus: '0 0 2px 3px #BFDFFF,0 0 2px 4px #0041D9'
      }
    },
    Track: {
      width: '100%'
    },
    Tracks: {
      borderRadius: '50%'
    }
  },
  RatingStars: {
    fontSize: 16,
    valueColor: '#0041D9',
    noValueColor: '#CDCDD3',
    marginRight: 4
  },
  Radio: {
    backgroundColor: '#FFF',
    borderColor: '#ADADB6',
    borderColorDisabled: '#CDCDD3',
    borderWidth: 2,
    borderWidthChecked: 5,
    size: 20
  },
  SearchBox: {
    boxShadow: '0 0 18px rgba(0, 0, 0, 0.1)',
    fontType: 'h6',
    height: 60,
    heightLarge: 70,
    iconSize: 16,
    iconSizeLarge: 22,
    iconColor: '#535364',
    large: {
      paddingLeft: 24
    }
  },
  Select: {
    chevronWidth: 40,
    chevronHeight: 28,
    chevronColor: '#535364'
  },
  Slider: {
    thumbBackgroundColor: '#0041D9',
    thumbBackgroundColorInteractive: '#0033AB',
    thumbBorderColor: '#FFF',
    thumbBorderWidth: 4,
    thumbBoxShadow: '0 4px 15px rgba(0, 0, 0, 0.15)',
    thumbFocusBoxShadow: '0 0 2px 3px #BFDFFF,0 0 2px 4px #0041D9',
    thumbBorderRadius: '50%',
    thumbLabelOffset: -60,
    thumbSize: 24,
    trackBackgroundColor: '#CDCDD3',
    trackBackgroundColorSelected: '#0041D9',
    trackBorderRadius: '999px',
    trackHeight: 2
  },
  SliderLabel: {
    caretSize: 8,
    caretMarginBottom: 8,
    fontType: 'body',
    fontColor: '#111116',
    backgroundColor: '#FFF',
    borderRadius: 12,
    padding: {
      X: 12,
      Y: 8
    }
  },
  Spinner: {
    animation: {
      duration: 0.5,
      easing: 'linear',
      iterations: 'infinite'
    }
  },
  Switch: {
    transition: '0.4s all',
    iconColorOn: '#0041D9',
    iconColorOff: '#FFF',
    iconBackgroundColorOn: '#FFF',
    iconBackgroundColorOff: '#CDCDD3',
    backgroundColor: '#EEEEF0',
    backgroundColorChecked: '#0041D9',
    focusBoxShadow: '0 0 2px 3px #BFDFFF,0 0 2px 4px #0041D9',
    borderRadius: '50%',
    sizes: {
      lg: {
        height: 30,
        width: 50,
        padding: 5
      },
      md: {
        height: 22,
        width: 38,
        padding: 4
      }
    }
  },
  SwitchGroup: {
    borderColor: '#CDCDD3',
    borderWidth: 1
  },
  Table: {
    borderColor: '#CDCDD3',
    borderWidth: 1,
    cellBackgroundColorLight: '#FFF',
    cellBackgroundColorDark: '#F7F7F7',
    focusBoxShadow: '0 0 2px 3px #BFDFFF,0 0 2px 4px #0041D9',
    fontType: {
      sm: 'bodySmall',
      md: 'bodySmall',
      lg: 'body'
    },
    headerBackgroundColorLight: '#FFF',
    headerBackgroundColorDark: '#EEEEF0',
    headerFontType: {
      sm: 'bodySmallHeading',
      md: 'bodySmallHeading',
      lg: 'bodyHeading'
    },
    headerSortIconColor: '#0041D9',
    horizontalPadding: {
      sm: 16,
      md: 16,
      lg: 16
    },
    rowBackgroundColorHover: '#EEF6FF',
    rowBackgroundColorSelected: '#DCEDFF',
    verticalPadding: {
      sm: 8,
      md: 12,
      lg: 16
    }
  },
  Tag: {
    borderRadius: 12,
    boxShadow: {
      focus: '0 0 2px 3px #BFDFFF,0 0 2px 4px #0041D9'
    },
    colors: {
      fontType: 'body',
      iconSize: 24,
      error: {
        background: '#FFE4E1',
        border: '#EF002D',
        foreground: '#EF002D',
        fontColor: '#AC001E',
        darkBackground: '#AC001E'
      },
      info: {
        fontColor: '#001962',
        background: '#DCEDFF'
      },
      success: {
        background: '#DAFACE',
        border: '#559E30',
        foreground: '#559E30',
        fontColor: '#2A6500',
        darkBackground: '#2A6500'
      },
      warning: {
        background: '#FFEDC0',
        border: '#BF8B00',
        foreground: '#FFA385',
        fontColor: '#725200',
        darkBackground: '#FF4D29'
      },
      transient: {
        foreground: '#0041D9'
      },
      gray: {
        fontColor: '#111116',
        background: '#EEEEF0'
      },
      closeable: {
        fontColor: '#111116',
        background: '#CDCDD3'
      },
      purple: {
        fontColor: '#6000B6',
        background: '#F7E3FF'
      },
      aqua: {
        fontColor: '#00343D',
        background: '#D3F6FD'
      },
      orange: {
        fontColor: '#D03C0B',
        background: '#FFE9E3'
      },
      transparent: {
        fontColor: '#FFF',
        background: 'rgba(0,0,0,0.6)'
      }
    },
    fontTypes: {
      sm: 'finePrintHeading',
      md: 'bodySmallHeading'
    },
    horizontalPadding: {
      sm: 4,
      md: 8
    },
    verticalPadding: 2,
    targetPadding: 8,
    closeButtonSize: 16,
    closeButton: {
      boxShadow: {
        focus: '0 0 2px 3px #BFDFFF,0 0 2px 4px #0041D9'
      },
      opacity: {
        hover: 0.6
      },
      borderRadius: '50%'
    }
  },
  Tabs: {
    backgroundColor: '#FFF',
    fontColorHover: '#0041D9',
    selectedTabIndicatorColor: '#0041D9',
    selectedTabIndicatorHeight: 4,
    Panel: {
      padding: 16
    },
    Tab: {
      fontWeight: 400,
      default: {
        borderRadius: 0,
        borderColor: '#CDCDD3',
        padding: 16,
        transition: {
          duration: 0.2,
          easing: 'ease-out',
          property: 'flex-shrink'
        }
      },
      file: {
        padding: 16,
        transition: {
          duration: 0.2,
          easing: 'ease-out',
          property: 'flex-shrink'
        },
        gradientColor: {
          hover: '#EEEEF0',
          active: '#CDCDD3'
        }
      }
    }
  },
  TextButton: {
    fontColor: '#0041D9',
    fontColorInverse: '#FFF',
    fontColorPrimary: '#0041D9',
    fontColorSecondary: '#111116',
    fontColorTertiary: '#535364'
  },
  Toast: {
    maxWidth: 500,
    borderRadius: 12,
    margin: 16,
    Provider: {
      zIndex: 200000
    },
    AnimatedList: {
      margin: 0,
      padding: 0
    }
  },
  ToolTip: {
    DialogBody: {
      paddingX: 16,
      paddingY: 8
    }
  },
  TriggerButton: {
    borderRadius: '50%',
    boxShadow: '0 0 2px 3px #BFDFFF,0 0 2px 4px #0041D9',
    size: 16,
    helpCircleFillColor: '#FFF',
    helpCircleFillColorActive: '#CDCDD3',
    helpCircleFillColorHover: '#EEEEF0',
    helpCircleStrokeColor: '#ADADB6',
    helpCircleStrokeColorActive: '#535364',
    helpCircleStrokeColorHover: '#ADADB6',
    helpQuestionFillColor: '#2A2A33',
    helpQuestionFillColorActive: '#2A2A33'
  },
  TriggerText: {
    borderBottomColor: '#0041D9',
    borderBottomWidth: 1,
    borderBottomStyle: 'dashed',
    padding: 0
  },
  Upsell: {
    headingFontType: 'h6',
    rowMediaSize: 48,
    columnMediaSize: 80,
    fontColorInverse: '#FFF',
    iconBackgroundColorInteractive: 'rgba(255, 255, 255, 0.3)'
  },
  UpsellBanner: {
    fontType: 'h6',
    mediaSize: 44,
    boxShadow: '0 1px 1px 0 rgb(79, 79, 79, 0.3)',
    padding: 16
  },
  VerticalNav: {
    boxShadow: '0 7px 20px rgba(0, 0, 0, 0.15)',
    backgroundColor: '#FFF',
    borderColor: '#CDCDD3',
    borderRadius: 12
  },
  VerticalNavItem: {
    backgroundColor: 'transparent',
    backgroundColorHover: '#CDCDD3',
    backgroundColorActive: '#DCEDFF',
    fontColor: '#111116',
    fontType: 'body',
    fontWeightActive: 700,
    horizontalSpacing: 24,
    verticalSpacing: 12,
    borderColor: 'transparent',
    borderColorActive: '#0041D9',
    borderWidth: 4,
    borderRadius: 12
  }
};
export var ThemeSkunkWorks = withNamespace({
  constellation: theme
}, 'constellation');